import Navigation from '../Navigation';
import { Outlet } from 'react-router-dom';
import { Customer, CustomerData } from '../../types/customer';

interface Props {
  customer?: Customer;
  cdpCustomer?: CustomerData;
  idToken: string;
}

function Layout(props: Props): JSX.Element {
  return (
    <div className='layout min-h-full pb-5 bg-gray-200'>
      <header>
        <Navigation customer={props.customer} cdpCustomer={props.cdpCustomer} idToken={props.idToken}/>
      </header>

      <Outlet />
    </div>
  );
}

export default Layout;
